import { Icon } from '@iconify/react/dist/iconify.js';

const escapeCell = (v) => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

const ExportOpportunitiesCSV = ({ data }) => {
  const exportToCSV = () => {
    const headers = [
      'Opp #', 'Description', 'Company', 'Salesperson',
      'Status', 'Stage', 'Prob', 'Value', 'Close Date', 'Type',
    ];

    const rows = data.map((row) =>
      [
        row.oppNumber,
        row.description,
        row.company,
        row.salesperson,
        row.status,
        row.stage,
        row.probability,
        Number.isFinite(Number(row.value)) ? Number(row.value) : '',
        formatDate(row.closeDate) || row.closeDate,
        row.customerType,
      ].map(escapeCell)
    );

    const csv = [headers.join(','), ...rows.map((r) => r.join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `opportunities_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      type="button"
      className="whitespace-nowrap font-medium flex flex-row items-center rounded-md gap-2 p-2 button-container text-sm transition-colors"
      onClick={exportToCSV}
    >
      <Icon icon="material-symbols:file-export-rounded" className="text-xl text-accent" />
      Export to CSV
    </button>
  );
};

export default ExportOpportunitiesCSV;
